angular.module('dnecom')
    .controller('ProductProcessGoogleProductCategoryController', ["$scope", "$uibModalInstance", "$http", "currentGoogleProductCategory", "notifications", function ($scope, $uibModalInstance, $http,
                                                                    currentGoogleProductCategory, notifications) {
        $scope.selectedNode = null;

        $scope.treeOptions = {
            nodeChildren: "children",
            dirSelectable: true,
            isLeaf: function isLeafFn(node) {
                return node.children && node.children.length === 0 || node.empty;
            }
        };
        $scope.expandedNodes = [];
        $scope.dataForTheTree = [];

        init();

        function init() {
            var params = {'_format': 'json'};
            if (currentGoogleProductCategory) {
                params['selectedNode'] = currentGoogleProductCategory.id;
            }
            $http
                .get(Routing.generate('api_google_product_categories_get_collection', params))
                .success(function(categories) {
                    angular.copy(categories, $scope.dataForTheTree);
                    if (currentGoogleProductCategory) {
                        selectNode($scope.dataForTheTree, $scope.expandedNodes);
                    }
                })
                .error(function(err) {
                    console.error(err);
                    notifications.danger('Invalid server response.');
                })
            ;
        }

        $scope.fetchChildNodes = function (node, expanded) {
            if (!expanded || node.children) {
                return;
            }
            $http
                .get(Routing.generate('api_google_product_categories_get_item', {id: node.id, '_format': 'json'}))
                .success(function(category) {
                    angular.copy(category, node);
                })
                .error(function(err) {
                    console.error(err);
                    notifications.danger('Invalid server response.');
                })
            ;
        };

        $scope.submit = function() {
            delete $scope.selectedNode.children;
            $uibModalInstance.close($scope.selectedNode);
        };

        $scope.closeModal = function () {
            $uibModalInstance.dismiss();
        };

        function selectNode(categories) {
            if (!categories) {
                return false;
            }
            for (let child of categories) {
                if (child.id === currentGoogleProductCategory.id) {
                    $scope.selectedNode = child;
                    return true;
                }
                if (selectNode(child.children)) {
                    $scope.expandedNodes.push(child);
                    return true;
                }
            }
            return false;
        }
    }]);
